    /* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import { Select, Icon, Spin, Empty, Modal } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { OPTION_IDS } from '../../../constants/app-constants';
import { isArray } from 'jquery';
import { optionsStore } from '../../../selectStore';
import Storage from './../../../services/local-store';
class Select2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            select2options: [],
            loading: false,
            selectdata: {},
            fetching: true
        };
    }
    componentDidMount() {
        this.setState((state) => ({ 'selectdata': this.props.selectdata }));
        console.log(this.props.selectdata);
        optionsStore.subscribe(() => console.log('optionsStore old', optionsStore.getState()))
    }

    componentDidUpdate(prevProps, pervState) {
        if (prevProps.selectdata.value != this.props.selectdata.value) {
            this.setState((state) => ({ 'selectdata': this.props.selectdata }));
        }
    }

    handleChange(value) {
        console.log(`selected ${value}`);
    }

    onChange(value) {

        // console.clear();
        let selectdata = this.state.selectdata;
        selectdata['value'] = value;


        // this.selectFetchCall();
        let text = null;

        // console.log(this.state.select2options);

        this
            .state
            .select2options
            .map((data, key) => {
                if (data['id'] === value) {
                    text = data['name'] || data['value'];
                }
            });


        selectdata['text'] = text;

        // console.log(selectdata);
        this.setState((state) => ({ 'selectdata': selectdata }));
        if (this.props.selectdata.name === 'service') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                serviceTime: data.service_time,
                                text: text
                            });
                    }
                })

        } else if (this.props.selectdata.name === 'room_opted' || this.props.selectdata.name === 'room_upgrade') {

            console.log(this.props.selectdata.name, value);
            if (value) {
                this
                    .state
                    .select2options
                    .map((data, key) => {
                        if (data.id === value) {
                            this
                                .props
                                .onselectChanges({
                                    id: this.props.selectdata.name,
                                    name: this.props.selectdata.name,
                                    value: value,
                                    parrentMode: this.props.selectdata.parrentMode,
                                    parrentName: this.props.selectdata.parrentName,
                                    amount: data.amount,
                                    package_id: data.package_id ? data.package_id : null,
                                    text: text
                                });
                        }
                    })
            }else{
                this
                .props
                .onselectChanges({
                    id: this.props.selectdata.name,
                    name: this.props.selectdata.name,
                    value: null,
                    parrentMode: this.props.selectdata.parrentMode,
                    parrentName: this.props.selectdata.parrentName,
                    amount: 0,
                    package_id: null,
                    text: null
                });
            }

        }

        else if (this.props.selectdata.name === 'room_eligible_ward' || this.props.selectdata.name === 'upgrade_room') {
            let type_of_package = null
            type_of_package = localStorage.getItem('type_of_package');

            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                amount: data.amount,
                                'room_charges': data.room_charges,
                                package_id: data.package_id ? data.package_id : null,
                                text: text
                            });
                    }
                })
        }
        else if (this.props.selectdata.name === 'package_name' || this.props.selectdata.name === 'additional_package_name') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {

                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.id,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                length_of_stay: data.length_of_stay,
                                text: text,
                                table: this.props.selectdata.table,
                                row: this.props.selectdata.row_group,
                                equservicecd: data.servicecd,
                                packageAmount: data.general_price,
                                packageName: data.ispackage,
                            });
                    }
                })

        }

        else if (this.props.selectdata.name === 'patient_list') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                serviceTime: data.service_time,
                                text: text,
                                patient_type_hims: data.PATIENTTYPE,
                            });
                    }
                })
        } else if (this.props.selectdata.name === 'doctorid' || this.props.selectdata.name === 'doctor_name') {            
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        else if (this.props.selectdata.name === 'investigation_name' || this.props.selectdata.name === 'drugs_name' || this.props.selectdata.name === 'procedures_name') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.id,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                length_of_stay: data.length_of_stay,
                                text: text,
                                table: this.props.selectdata.table,
                                row: this.props.selectdata.row_group
                            });
                    }
                })

        }

        else if (this.props.selectdata.name === 'privilege_name') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.id,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        
        else if (this.props.selectdata.name === 'ot_hours' || this.props.selectdata.name === 'room_isolation_charges' || this.props.selectdata.name === 'icu_isolation_charges' || this.props.selectdata.name === 'room_highend_investigations' || this.props.selectdata.name === 'icu_highend_investigations' || this.props.selectdata.name === 'room_highend_drugs_implants' || this.props.selectdata.name === 'room_highend_implants' || this.props.selectdata.name === 'icu_highend_drugs_implants' || this.props.selectdata.name === 'ot_cath_highend_drugs_implants' || this.props.selectdata.name === 'general_highend_equipments' || this.props.selectdata.name === 'ot_equipments' || this.props.selectdata.name === 'blood_components' || this.props.selectdata.name === 'dept_for_corss_consultations' || this.props.selectdata.name === 'physiotherapys' || this.props.selectdata.name === 'surgery_procedure_name'  || this.props.selectdata.name === 'seropositive' || this.props.selectdata.name === 'additional_surgery_procedure_name') {
            this.state.select2options.map((data, key) => {
                if (data.id === value) {
                    this.props.onselectChanges({
                        id: this.props.selectdata.id,
                        name: this.props.selectdata.name,
                        value: value,
                        service_id: data.id,
                        service_data_id: data.service_id,
                        text: text,
                        row: this.props.selectdata.row_group,
                        table: this.props.selectdata.table,
                    });
                }
            })
        }
        else if (this.props.selectdata.name === 'excludes_service_id') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.id,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                text: (data.service_name),
                                table: this.props.selectdata.table,
                                row: this.props.selectdata.row_group,
                                selected_option: data
                            });
                    }
                })
        }
        
        else if (this.props.selectdata.name === 'ins_ot_hours' || this.props.selectdata.name === 'ins_room_isolation_charges' || this.props.selectdata.name === 'ins_icu_isolation_charges' || this.props.selectdata.name === 'ins_room_highend_investigations' || this.props.selectdata.name === 'ins_icu_highend_investigations' || this.props.selectdata.name === 'ins_room_highend_drugs_implants' || this.props.selectdata.name === 'ins_icu_highend_drugs_implants' || this.props.selectdata.name === 'ins_ot_cath_highend_drugs_implants' || this.props.selectdata.name === 'ins_general_highend_equipments' || this.props.selectdata.name === 'ins_ot_equipments' || this.props.selectdata.name === 'ins_blood_components' || this.props.selectdata.name === 'ins_dept_for_corss_consultations' || this.props.selectdata.name === 'ins_physiotherapys' || this.props.selectdata.name === 'ins_surgery_procedure_name' || this.props.selectdata.name === 'ins_ail_surgery_procedure_name'|| this.props.selectdata.name === 'seropositive' || this.props.selectdata.name === 'ot_cath_instruments' || this.props.selectdata.name === 'ot_cath_disinfection_charges' || this.props.selectdata.name === 'ot_cath_cssd_charges' || this.props.selectdata.name === 'ot_cath_equipment_charges' || this.props.selectdata.name === 'ins_medical_record_charges' || this.props.selectdata.name === 'ins_ward_consumables' || this.props.selectdata.name === 'ins_fnb_charges' || this.props.selectdata.name === 'ins_physiotherapy_charges' || this.props.selectdata.name === 'ins_diet_consulation_charges' || this.props.selectdata.name === 'ins_surgery_procedure_charges') {
            this.state.select2options.map((data, key) => {
                if (data.id === value) {
                    this.props.onselectChanges({
                        id: this.props.selectdata.id,
                        name: this.props.selectdata.name,
                        value: value,
                        service_id: data.id,
                        text: text,
                        row: this.props.selectdata.row_group,
                        table: this.props.selectdata.table,
                        sub_data: data,
                    });
                }
            })
        }

        // else if (this.props.selectdata.name === 'ins_room_highend_implants') {
        //     this.state.select2options.map((data, key) => {
        //         console.log("datadatdatdatdadadad",data, value)
        //         if (data.id === value) {
        //             this.props.onselectChanges({
        //                 id: this.props.selectdata.id,
        //                 name: this.props.selectdata.name,
        //                 value: value,
        //                 service_id: data.id,
        //                 text: text,
        //                 row: this.props.selectdata.row_group,
        //                 table: this.props.selectdata.table,
        //             });
        //         }
        //     })
        // }
        else if (this.props.selectdata.name === 'ins_package_name' || this.props.selectdata.name === 'ins_additional_package_name' || this.props.selectdata.name === 'ins_add_procedure_name' || this.props.selectdata.name === 'pre_ex_condition_name') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.id,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                length_of_stay: data.length_of_stay,
                                text: text,
                                equservicecd: data.servicecd,
                                packageAmount: data.general_price,
                                ispackage: data.ispackage,
                                table: this.props.selectdata.table,
                                row: this.props.selectdata.row_group
                            });
                    }
                })

        }
        else 
        if (this.props.selectdata.name === 'nmename') { 
            this
            .state
            .select2options
            .map((data, key) => {
                if (data.id === value) {
                    this
                        .props
                        .onselectChanges({
                            id: this.props.selectdata.id,
                            name: this.props.selectdata.name,
                            value: value,
                            parrentMode: this.props.selectdata.parrentMode,
                            parrentName: this.props.selectdata.parrentName,
                            text: data.service,
                            table: this.props.selectdata.table,
                            row: this.props.selectdata.row_group,
                            selected_option: data
                        });
                }
            })
        }
        else if (this.props.selectdata.name === 'service_type') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                form_type: data.form_type_id,
                                text: text
                            });
                    }
                })

        } 
        else if (this.props.selectdata.name === 'payer') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        else if (this.props.selectdata.name === 'zone') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        else if (this.props.selectdata.name === 'insurance_company_name') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        else if (this.props.selectdata.name === 'cathfilter') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        else if (this.props.selectdata.name === 'counsellor') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        else if (this.props.selectdata.name === 'reason') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                call_log_back_date_field: data.call_log_back_date_field,
                                call_log_eda_field: data.call_log_eda_field,
                                call_log_ip_number_field:data.call_log_ip_number_field,
                                call_log_surgery_date_field:data.call_log_surgery_date_field,
                                text: text
                            });
                    }
                })
        }

        else {
            this
                .props
                .onselectChanges({
                    id: this.props.selectdata.name,
                    text: text,
                    name: this.props.selectdata.name,
                    value: value,
                    parrentMode: this.props.selectdata.parrentMode,
                    parrentName: this.props.selectdata.parrentName
                });
        }
        

    }

    onBlur() {
        console.log('blur');
        console.log(this.props);
        // this.selectFetchCall(); this.selectFetchCall();
    }

    onFocus() {
        console.log('focus');
        this.setState({ select2options: [], loading: true });
        //console.log(this.props);
        this.selectFetchCall();
    }

    // onSearch(val) {
    //     console.log('search:', val);
    // }
    onSearch = (val) => {
        console.log('search:', val, this.props);
        const searchFeilds = ['ins_icu_highend_investigations', 'surgery', 'doctor_name', 'additional_surgery_procedure_name', 'ins_add_procedure_name', 'ins_ail_surgery_procedure_name', 'ins_room_highend_drugs_implants', 'ins_surgery_procedure_charges', 'ins_additional_package_name','additional_package_name']
        if ( this.props.selectdata && searchFeilds.includes(this.props.selectdata.name)) {
            this.selectFetchCall(val);
        }
    }

    selectFetchCall(val) {
        this.setState({ fetching: true });
        const {
            getQueueListBasedonUnit,
            master_unit,
            getAppointmentDoctorsById,
            master_department,
            master_service,
            master_doctor,
            getPlebos,
            master_operator,
            getRolesList,
            getAccessLevels,
            getQueueListDropDown,
            getChemists,
            getServicesList,
            getDispatchers,
            getMasterServices,
            getAppointmentBookingReasons,
            getPatientDetailsForApptSlot,
            getPrivileges,
            getDoctorsList,
            getProcessStages,
            getPatientTypes,
            getServiceNames,
            getRoomsForAppointmentSlotBlocking,
            getDoctorSpecialities,
            getDoctorsforDropdown,
            getUsersList,
            getProcedures,
            getCashNonPackageRoomsByUnitId,
            getAllInsuranceCompanies,
            getAllTpas,
            getPreExistingConditions,
            getRoomUpgradeReasons,
            getCounsellingType,
            getMasterAilmentCappingStatusOptions,
            getMasterPatientTypes,
            getMasterInsuranceTypes,
            getMasterSumInsuredFourYearsBackOptions,

            getMasterInsuranceStatus,
            getBreaktimeReasons,
            getMasterPreAuthStatus,
            getMasterCareManagement,
            getMasterEstimateTypes,
            getCounsellingSkipReasons,
            getPackagesForDropDown,
            getPackagesPricesById,
            getNonPackagePrices,
            getPrivilegesList,
            getDepartmentsFromPatients,
            getNurseStationDropdownFromPatients,
            getConsentRejectReasons,
            getMasterServicesForNurse,
            getMasterProceduresForNurse,
            getMasterDrugsForNurse,
            getCounsellingStationsDropDown,
            getFormTypesforDropdown,
            getMasterCabins,
            getPaymentTypes,
            getServicesByHeaderId,
            getMasterNMEs,
            getRemedinetPayerlist,
            getRemedinetZoneslist,
            getRemedinetInsurancesCompanyList,
            getUsersForTokenGenerator,
            getDepartmentsFromDoctors,
            getCallLogCategories,
            getCallLogCategoryReasons,
            getMasterTariffs,
            

        } = networkList;
        if (this.props.selectdata.name === 'unit' || this.props.selectdata.name === 'unit_id') {

            postService(master_unit, 'GET', 'null').then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'service_type') {

            // postService(getPrivileges, 'GET', 'null').then(res => {

            //     if (res) {
            //         this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
            //     } else {
            //         this.setState({ fetching: false });
            //     }
            // });
            postService(getPrivileges, 'GET', 'null').then(res => {
                console.log('PROPS2', this.props);
                if (res) {
                    let filteredData = res.data;
        
                    if (this.props.tokenData[2].value === null) {
                        //filteredData = filteredData.filter(item => item.name !== 'Discharge & Checkout');
                        filteredData = filteredData.filter(item => item.only_admission !== '1');
                    }
        
                    this.setState((state) => ({ select2options: filteredData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'service_type_admission') {
            console.log('PROPS', this.props.filtereData[5].value);
        
            postService(getPrivileges, 'GET', 'null').then(res => {
                if (res) {
                    let filteredData = res.data;
                    Storage.store('privileges2', filteredData);
                    if (this.props.filtereData[5].value === null) {
                        //filteredData = filteredData.filter(item => item.name !== 'Discharge & Checkout');
                        filteredData = filteredData.filter(item => item.only_admission !== '1');
                    }
        
                    this.setState((state) => ({ select2options: filteredData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        

        if (this.props.selectdata.name === 'financial_couselling') {

            postService(getPrivileges, 'GET', 'null').then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'financial_couselling_skip') {

            postService(getPrivilegesList, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['privilege_name']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'counsellor_id') {

            postService(getUsersList, 'GET', 'null').then(res => {

                if (res) {
                    let newData = [];
                    res.data.map((userData, roomKey) => {

                        newData.push({
                            'id': userData['id'],
                            'name': userData['username']
                        })

                    })
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'patient_type_blocked') {
            postService(getPatientTypes, 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }


        if (this.props.selectdata.name === 'insurance_company') {
            postService(getAllInsuranceCompanies, 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'tpa_name') {
            postService(getAllTpas, 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }


        if (this.props.selectdata.name === 'condition_name') {
            postService(getPreExistingConditions, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'department' || this.props.selectdata.name === 'department_id') {
            let user_data = ''
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
             user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService(getDepartmentsFromDoctors, 'POST', {
                "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}    
            }).then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'tariff') {
            let user_data = ''
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
             user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService(getMasterTariffs, 'POST', {
                "data": { "page_no":"1", "unit_id": user_data['unitid'] ? user_data['unitid'] : '' }    
            }).then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });  
        }



        if (this.props.selectdata.name === 'doctorid') {
            postService(getDoctorsforDropdown, 'GET', 'null').then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }


        // if (this.props.selectdata.name === 'surgery_procedure_name' || this.props.selectdata.name === 'additional_procedure' || this.props.selectdata.name === 'surgery' || this.props.selectdata.name === 'additional_procdure_id') {
            if ( this.props.selectdata.name === 'surgery' || this.props.selectdata.name === 'additional_surgery_procedure_name' || this.props.selectdata.name === 'ins_add_procedure_name'|| this.props.selectdata.name ==='ins_ail_surgery_procedure_name') {
            // postService(getProcedures, 'GET', 'null').then(res => {
            //     if (res) {
            //         this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
            //     } else {
            //         this.setState({ fetching: false });
            //     }
            // });
            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid;
            let payload = {
                // "tariff_id" : "TR1",
                "search_key": val || '',
                "unit_id": user_unit_id
            }
        postService('getProcedures', 'POST', {data:payload}).then(async(res) => {
        if (res) {
                this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
            } else {
                this.setState({ fetching: false });
            }
        });
        }

        if (this.props.selectdata.name === 'counselling_type') {
            postService(getCounsellingType, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }



        if (this.props.selectdata.name === 'doctor') {
            let {
                id,
                slug
            } = this.props.match.params;

            if (id === 'appointments') {
                postService(getAppointmentDoctorsById, 'POST', {
                    'data': {
                        "unit": this.getQueuevalue('unit') ? this.getQueuevalue('unit') : this.getQueuevalue('unit_id'),
                        "department": this.getQueuevalue('department') ? this.getQueuevalue('department') : this.getQueuevalue('department_id'),
                        "service_group": this.getQueuevalue('service_group') ? this.getQueuevalue('service_group') : this.getQueuevalue('service_group_id')
                    }
                }).then(res => {

                    if (res) {
                        this.setState((state) => ({
                            select2options: res.data,
                            loading: false,
                            fetching: false
                        }));
                    } else {
                        this.setState({ fetching: false });
                    }
                });
            } else if (id === 'generate-token') {
                postService(getDoctorsforDropdown, 'GET', 'null').then(res => {

                    if (res) {
                        this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                    } else {
                        this.setState({ fetching: false });
                    }
                });
            } else {
                postService(master_doctor, 'POST', {
                    "departmentID": this.getQueuevalue('department') ? this.getQueuevalue('department') : this.getQueuevalue('department_id')
                }).then(res => {

                    if (res) {
                        this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                    } else {
                        this.setState({ fetching: false });
                    }
                });
            }
        }

        if (this.props.selectdata.name === 'role_id' || this.props.selectdata.name === 'role') {
          
            postService(getRolesList, 'GET', null).then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                }
                 else {
                    this.setState({ fetching: false });
                }
            });
        }


        if (this.props.selectdata.name === 'speciality_id') {
            postService(getDoctorSpecialities, 'GET', null).then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        // if (this.props.selectdata.name === 'accessLevel') {
        //     postService(getAccessLevels, 'GET', null).then(res => {

        //         if (res) {
        //             this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
        //         } else {
        //             this.setState({ fetching: false });
        //         }
        //     });
        // }

        
        if (this.props.selectdata.name === 'payment') {
            var data = [
                {
                    'id': 1,
                    'name': 'Cash'
                }, {
                    'id': 2,
                    'name': 'Insurance'
                }
                , {
                    'id': 3,
                    'name': 'Corporate'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'payment1') {
            var data = [
                {
                    'id': 'All',
                    'name': 'All'
                },
                {
                    'id': 'Cash',
                    'name': 'Cash'
                }, {
                    'id': 'Insurance',
                    'name': 'Insurance'
                }
                , {
                    'id': 'Corporate',
                    'name': 'Corporate'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }


        if (this.props.selectdata.name === 'select_difference') {
            var data = [
                {
                    'id': 'room_differance',
                    'name': 'Room Difference Amount'
                }, {
                    'id': 'pro_rata_differance',
                    'name': 'Pro Rata Difference Amount'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'type_of_management') {
            postService(getMasterCareManagement, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });


        }


        if (this.props.selectdata.name === 'sum_insured_four_years_back') {
            postService(getMasterSumInsuredFourYearsBackOptions, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });


        }



        if (this.props.selectdata.name === 'type_of_package') {
            postService(getMasterEstimateTypes, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });


        }

        //         Room upgrade Reason
        // Non availability
        // Complimentary
        // Upgrade Excess Charge Payable




        if (this.props.selectdata.name === 'ailment_capping_status') {



            postService(getMasterAilmentCappingStatusOptions, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
            // var data = [
            //     {
            //         'id': 1,
            //         'name': 'Yes'
            //     }, {
            //         'id': 2,
            //         'name': 'No'
            //     }]
            // this.setState((state) => ({ select2options: data, loading: false, fetching: false }));


        }

        // if (this.props.selectdata.name === 'room_upgrade_reason') {
        //     postService(getRoomUpgradeReasons, 'GET', 'null').then(res => {
        //         if (res) {
        //             let newData = [];
        //             if (res.data.length !== 0) {
        //                 res.data.map((roomData, roomKey) => {
        //                     newData.push({
        //                         'id': roomData['id'],
        //                         'name': roomData['value']
        //                     })

        //                 })
        //             }
        //             this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
        //         } else {
        //             this.setState({ fetching: false });
        //         }
        //     });



        // }

        if (this.props.selectdata.name === 'type_of_insurance') {

            postService(getMasterInsuranceTypes, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });


        }


        if (this.props.selectdata.name === 'insurance_status') {

            postService(getMasterInsuranceStatus, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }


        if (this.props.selectdata.name === 'pre_auth_status') {
            postService(getMasterPreAuthStatus, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }


        if (this.props.selectdata.name === 'claim_type') {
            postService(getMasterInsuranceTypes, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });


        }


        if (this.props.selectdata.name === 'patient_type') {
            postService(getMasterPatientTypes, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    if (res.data && Array,isArray(res.data) && res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });


        }



        if (this.props.selectdata.name === 'room_opted' || this.props.selectdata.name === 'room_upgrade') {
            let user_data = null;
            let package_data = null;
            let type_of_package = null
            let payment_type = null;
            payment_type = localStorage.getItem('payment');
            if (localStorage.getItem('user_data') !== null) {
                user_data = JSON.parse(localStorage.getItem('user_data'))
                package_data = localStorage.getItem('package_name')
                type_of_package = localStorage.getItem('type_of_package');
                let payload = {}
                let url = null;
                let room_eligible_ward_cost = localStorage.getItem('room_eligible_ward_cost');

                if (type_of_package == 1) {
                    url = getPackagesPricesById;
                    payload = {
                        "package_id": package_data,
                        "unit_id": user_data['unitid'],
                        "payment_type": payment_type
                    }

                    postService(url, 'POST', {
                        "data": payload
                    }).then(res => {

                        if (res) {
                            let newData = [];
                            if (res.data.length !== 0) {
                                res.data.map((roomData, roomKey) => {
                                    if (type_of_package == 1) {
                                        newData.push({
                                            'disabled': (this.props.selectdata.name === 'room_upgrade') ? (room_eligible_ward_cost !== null && parseFloat(room_eligible_ward_cost) >= parseFloat(roomData['value'])) ? true : false : false,
                                            'id': roomData['room_name'],
                                            'name': roomData['room_name'].charAt(0).toUpperCase() + roomData['room_name'].slice(1),
                                            'amount': roomData['value'],
                                            'package_id': roomData['id']
                                        })
                                    }

                                })
                            }
                            this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                        } else {
                            this.setState({ select2options: [], fetching: false });
                        }
                    });
                } else {
                    postService(getCashNonPackageRoomsByUnitId, 'POST', {
                        "unit_id": user_data['unitid']
                    }).then(res => {

                        if (res) {
                            let newData = [];
                            if (res.data.length !== 0) {
                                res.data.map((roomData, roomKey) => {
                                    newData.push({
                                        'disabled': (this.props.selectdata.name === 'room_upgrade') ? (room_eligible_ward_cost !== null && parseFloat(room_eligible_ward_cost) >= parseFloat(roomData['amount'])) ? true : false : false,
                                        'id': roomData['id'],
                                        'name': roomData['room_name'],
                                        'amount': roomData['amount'],
                                        'package_id': roomData['id']
                                    })
                                    console.log('newDATA', newData);

                                })
                            }
                            this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                        } else {
                            this.setState({ select2options: [], fetching: false });
                        }
                    });


                }
            } else {
                this.setState({ fetching: false });
            }




            // var data = [
            //     {
            //         'id': 1,
            //         'name': 'Opted 1'
            //     }, {
            //         'id': 2,
            //         'name': 'Opted 2'
            //     }
            // ]
            // this.setState((state) => ({ select2options: data, loading: false, fetching: false }));

            // postService(getAccessLevels, 'GET',null).then(res => {     if (res) {
            // this.setState((state) => ({select2options: res.data, loading: false}));     }
            // });
        }


        if (this.props.selectdata.name === 'room_eligible_ward' || this.props.selectdata.name === 'upgrade_room') {
            let package_data = null;
            let type_of_package = null
            let payment_type = null;
            let insurance_company = null;
            let tpa = null;
            let user_data = null;
            let room_eligible_ward_cost = 0;
            room_eligible_ward_cost = localStorage.getItem('room_eligible_ward_cost');
            if (localStorage.getItem('package_name') !== null) {
                package_data = localStorage.getItem('package_name')
            }
            type_of_package = localStorage.getItem('type_of_package');

            payment_type = localStorage.getItem('payment');
            if (localStorage.getItem('insurance_company') !== null || localStorage.getItem('tpa_name') !== null) {
                insurance_company = localStorage.getItem('insurance_company')
                tpa = localStorage.getItem('tpa_name');
            }

            if (localStorage.getItem('user_data') !== null) {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }

            let payload = {}
            let url = null;
            if (type_of_package == 1) {
                url = getPackagesPricesById;
                payload = {
                    "unit_id": user_data['unitid'],
                    "package_id": package_data,
                    "payment_type": payment_type
                }
            } else {
                url = getNonPackagePrices;
                payload = {
                    "unit_id": user_data['unitid'],
                    "payment_type": payment_type,
                    "insurance_company": insurance_company,
                    "tpa": tpa
                }
            }



            postService(url, 'POST', {
                "data": payload
            }).then(res => {

                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            if (type_of_package == 1) {
                                newData.push({
                                    'disabled': (this.props.selectdata.name === 'upgrade_room') ? (room_eligible_ward_cost !== null && parseFloat(room_eligible_ward_cost) >= parseFloat(roomData['room_charges'])) ? true : false : false,
                                    'id': roomData['room_name'],
                                    'name': roomData['room_name'].charAt(0).toUpperCase() + roomData['room_name'].slice(1),
                                    'amount': roomData['value'],
                                    'room_charges': roomData['room_charges'],
                                    'package_id': roomData['id']
                                })
                            } else {
                                newData.push({
                                    'disabled': (this.props.selectdata.name === 'upgrade_room') ? (room_eligible_ward_cost !== null && parseFloat(room_eligible_ward_cost) >= parseFloat(roomData['value'])) ? true : false : false,
                                    'id': roomData['id'],
                                    'name': roomData['room_name'],
                                    'amount': roomData['value'],
                                    'room_charges': roomData['value'],
                                    'package_id': roomData['id']
                                })
                            }

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });






        }

        if (this.props.selectdata.name === 'package_name'|| this.props.selectdata.name === 'additional_package_name') {
                    let user_data = JSON.parse(localStorage.getItem('user_data'));
                    let user_unit_id = user_data.unitid;
                    let payment_type = this.props.basic_info['payment_type'];
                    let payment_mode;
                    if (payment_type === 1) {
                    payment_mode = 'Cash';
                    }
                    if (payment_type === 2) {
                    payment_mode = 'Insurance';
                    }

                    // postService(getPackagesForDropDown, 'POST', { "data" : { "payment_type": payment_mode, 'unit_id' : user_unit_id, 'insurance_company' : null, 'tpa' : null } } ).then(res => {
                    postService(getPackagesForDropDown, 'POST', { "data": { "payment_type": payment_type, 'unit_id': user_unit_id, 'tariff_mapped': "TR1" } }).then(res => {
                    if (res) {
                        let newData = [];
                        if (res.data.length !== 0) {
                            res.data.map((roomData, roomKey) => {
                                newData.push({
                                    'id': roomData['id'],
                                    'name': roomData['name'],
                                    'length_of_stay': roomData['length_of_stay'],
                                    'servicecd': roomData['service_code'],
                                    'general_price': roomData['general_price'],
                                })

                            })
                        }
                        this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                    } else {
                        this.setState({ fetching: false });
                    }
                    })


        }



        if (this.props.selectdata.name === 'break_reason_dropdown') {

            postService(getBreaktimeReasons, 'GET', 'null').then(res => {
                // console.log(res);
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['reason']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }




        if (this.props.selectdata.name === 'room_upgrade_reason') {


            let payment = localStorage.getItem('payment')
            if (payment === 'Insurance') {
                payment = 2;
            } else {
                payment = 1;
            }

            postService(getRoomUpgradeReasons, 'POST', {
                "data": {
                    "payment_type": payment
                }
            }).then(res => {

                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['value']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }






        if (this.props.selectdata.name === 'reason_dropdown') {

            postService(getCounsellingSkipReasons, 'GET', 'null').then(res => {
                console.log(res);
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((roomData, roomKey) => {
                            newData.push({
                                'id': roomData['id'],
                                'name': roomData['reason']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'days') {
            var data = [
                {
                    'id': 1,
                    'name': 'Monday'
                }, {
                    'id': 2,
                    'name': 'Tuesday'
                }, {
                    'id': 3,
                    'name': 'Wednesday'
                }, {
                    'id': 4,
                    'name': 'Thursday'
                }, {
                    'id': 5,
                    'name': 'Friday'
                }, {
                    'id': 6,
                    'name': 'Saturday'
                }, {
                    'id': 7,
                    'name': 'Sunday'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));


        }

        if (this.props.selectdata.name === 'gender') {
            var data = [
                {
                    'id': 'male',
                    'name': 'Male'
                }, {
                    'id': 'female',
                    'name': 'Female'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'emergency') {
            var data = [
                {
                    'id': '1',
                    'name': 'Yes'
                }, {
                    'id': '0',
                    'name': 'No'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'admission') {
            var data = [
                {
                    'id': '1',
                    'name': 'Yes'
                }, {
                    'id': '0',
                    'name': 'No'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'whatsapp') {
            var data = [
                {
                    'id': '1',
                    'name': 'Yes'
                }, {
                    'id': '0',
                    'name': 'No'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'vip_status') {
            var data = [
                {
                    'id': 'Y',
                    'name': 'Yes'
                }, {
                    'id': 'N',
                    'name': 'No'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'send_whatsapp_sms') {
            var data = [
                {
                    'id': '1',
                    'name': 'Yes'
                }, {
                    'id': '0',
                    'name': 'No'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        

        if (this.props.selectdata.name === 'care_management') {
            var data = [
                {
                    'id': '1',
                    'name': 'Medical'
                }, {
                    'id': '2',
                    'name': 'Surgical'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'form_type') {

            var data = [
                {
                    'id': '1',
                    'name': 'Counselling'
                }, {
                    'id': '2',
                    'name': 'Non Counselling'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));

            // postService(getFormTypesforDropdown, 'GET', 'null').then(res => {
            //     console.log(res);
            //     if (res) {
            //         let newData = [];
            //         if (res.data.length !== 0) {
            //             res.data.map((data, roomKey) => {
            //                 newData.push({
            //                     'id': data['id'].toString(),
            //                     'name': data['name']
            //                 })

            //             })
            //         }
            //         this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
            //     } else {
            //         this.setState({ fetching: false });
            //     }
            // });
        }

        if (this.props.selectdata.name === 'payment_type') {
            var data = [
                {
                    'id': '1',
                    'name': 'Cash'
                }, {
                    'id': '2',
                    'name': 'Insurance'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'patient_list') {
            // let patientidentity, patienttype;
            // if (this.getFormvalue('ipnumber')) {
            //     patientidentity = this.getFormvalue('ipnumber');
            //     patienttype = 'IP'
            // } else {
            //     patientidentity = this.getFormvalue('umr');
            //     patienttype = 'OP'
            // }

            // var obj = {
            //     "patientidentity": (patientidentity === null) ? '' : patientidentity,
            //     "mobileno": this.getFormvalue('mobile'),
            //     "patienttype": patienttype,
            // };
            // postService(getPatientDetailsForApptSlot, 'POST', { data: obj }).then(res => {
            let res = { 'data': this.props.searchPatient };

            if (res) {
                var data = [];
                if (res.data.length > 0) {
                    for (var s = 0; s < res.data.length; s++) {
                        let { PATIENTNAME, UMRNO, MOBILE_NUMBER, GENDER, AGE, ADMISSIONNO } = res.data[s];

                        let ind_data_txt = PATIENTNAME + ',' + UMRNO + ',' + MOBILE_NUMBER + ',' + GENDER + ',' + AGE;
                        ind_data_txt = ind_data_txt.replace(/,+/g, ','); // replace double commas with single comma
                        res.data[s]['name'] = ind_data_txt;

                        let ind_data = { NAME: PATIENTNAME, UMR: UMRNO, MOBILENO: MOBILE_NUMBER, GENDER: GENDER, IP: ADMISSIONNO ? ADMISSIONNO : null, AGE: AGE, ID: s };
                        let ind_data_str = JSON.stringify(ind_data);
                        res.data[s]['id'] = ind_data_str.slice(1, -1);

                        data.push(res.data[s]);
                    }
                }

                this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
            } else {
                this.setState({ fetching: false });
            }
            // });
        }

        if (this.props.selectdata.name === 'bill_value') {
            var data = [{
                "id":"1",
                "name":"< 1 L"
             },{
                "id":"2",
                "name":"1 to 3 L"
             },{
                "id":"3",
                "name":"> 3 L"
             }]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'payer_type') {
            var data = [
                {
                    'id': 'GENERAL',
                    'name': 'General'
                }, {
                    'id': 'INSURANCE',
                    'name': 'Insurance'
                },{
                    'id': 'CORPORATE',
                    'name': 'Corporate'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'departmentbyunit') {
            let user_data = ''
           if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'))
           }
            postService(getDepartmentsFromPatients, 'POST', {
                "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}                   
            }).then(res => {
    
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ select2options: [], fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'nursestationbyunit') {
            let user_data = ''
           if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'))
           }
            postService(getNurseStationDropdownFromPatients, 'POST', {
                "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}                   
            }).then(res => {
    
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ select2options: [], fetching: false });
                }
            });
        }
       
        if (this.props.selectdata.name === 'consent_reason') {
            var data = [
                {
                    'id': '2',
                    'name': 'Machine Breakdown'
                },{
                    'id': '1',
                    'name': 'Not Available'
                }
            ]
            
            postService(getConsentRejectReasons, 'GET', 'null').then(res => {
                console.log(res);
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((data, roomKey) => {
                            newData.push({
                                'id': data['id'],
                                'name': data['name']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });            
        }

        if (this.props.selectdata.name === 'investigation_name') {
            const { investigationSelectID } = this.props;
            postService(getMasterServicesForNurse, 'GET', 'null').then(res => {
                if (res) {
                    if (investigationSelectID) {
                        const filterOptions = res.data.filter(item => {
                            return !investigationSelectID.some(id => id.value === item.id)
                        })
                        this.setState((state) => ({ select2options: filterOptions, loading: false, fetching: false }));
                    } else {
                        this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                    }
                } else {
                    this.setState({ fetching: false });
                }
            });
        }  
        if (this.props.selectdata.name === 'procedures_name') {
            const { proceduresSelectID } = this.props;
            postService(getMasterProceduresForNurse, 'GET', 'null').then(res => {
                if (res) {
                    if (proceduresSelectID) {
                        const filterOptions = res.data.filter(item => {
                            return !proceduresSelectID.some(id => id.value === item.id)
                        })
                        this.setState((state) => ({ select2options: filterOptions, loading: false, fetching: false }));
                    } else {
                        this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                    }
                } else {
                    this.setState({ fetching: false });
                }
            });
        }  
        if (this.props.selectdata.name === 'drugs_name') {
            const { drugsSelectID } = this.props;
            postService(getMasterDrugsForNurse, 'GET', 'null').then(res => {
                if (res) {
                    if (drugsSelectID) {
                        const filterOptions = res.data.filter(item => {
                            return !drugsSelectID.some(id => id.value === item.id)
                        })
                        this.setState((state) => ({ select2options: filterOptions, loading: false, fetching: false }));
                    } else {
                        this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                    }
                } else {
                    this.setState({ fetching: false });
                }
            });
        } 
// FC2 merging start
        if (this.props.selectdata.name === 'counselling_stations') {
            try {
            const params = new URLSearchParams(this.props.location.search);
            let { slug } = this.props.match.params;
            let unitData = '';
            if (slug === 'edit-user') {
                console.log('inside', this.getQueuevalue('unit'))
                unitData = this.getQueuevalue('unit');
            }
            else {
                unitData = this.getQueuevalue('unit') ? this.getQueuevalue('unit') : this.getQueuevalue('unit_id');
            }
            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid;
            postService(getCounsellingStationsDropDown, 'POST', { "unit_id": unitData ? unitData : user_unit_id }).then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
            } catch (error) {
            this.setState((state) => ({ 'selet_options': [] }));
            console.log(error);
        }
        }
 
        if (this.props.selectdata.name === 'privilege_name') {
            try {
            const { privilageSelectID } = this.props;
            postService(getPrivileges, 'GET', 'null').then(res => {
                if (res) {
                    localStorage.setItem('privilege_total', res.data.length);
                    if (privilageSelectID) {
                        const filterOptions = res.data.filter(item => {
                            return !privilageSelectID.some(id => id.value === item.id)
                        })
                        this.setState((state) => ({ select2options: filterOptions, loading: false, fetching: false }));
                    } else {
                        this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                    }
                } else {
                    this.setState({ fetching: false });
                }
            });
        } catch (error) {
            this.setState((state) => ({ 'selet_options': [] }));
            console.log(error);
        }

        }
        if (this.props.selectdata.name === 'cabin_id') {
            try {
            postService(getMasterCabins, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    let cabin_id = localStorage.getItem('cabin_id');
                    if (res.data&&res.data.length !== 0) {
                        res.data.map((data, key) => {
                            newData.push({
                                // 'disabled': (this.props.selectdata.name === 'cabin_id') ? (cabin_id !== null && cabin_id == data['id']) ? true : false : false,
                                // 'disabled': (this.props.selectdata.name === 'cabin_id') ? ( cabin_id == data['id']) ? true : false : false,
                                'id': data['id'],
                                'name': data['cabin_name']
                            })
                        })
                        this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                    }else{
                        this.setState({ loading: false,select2options:[],fetching: false }); 
                    }
                } else {
                    this.setState({ loading: false,select2options:[],fetching: false });
                }
            });
        } catch (error) {
            this.setState((state) => ({ 'selet_options': [],loading: false,fetching: false }));
            console.log(error);
        }
        }
        if (this.props.selectdata.name === 'payment_mode') {
            try {
                postService(getPaymentTypes, 'GET', {}).then(res => {
                    if (res['status']) {
                        let newData = [];
                        if (res.data.length !== 0) {
                            res.data.map((rdata, rkey) => {
                                newData.push({
                                    'id': rdata['id'],
                                    'name': rdata['name']
                                })
    
                            })
                        }
                        this.setState((state) => ({ 'select2options': newData, 'loading': false, 'fetching': false }));
                    } else {
                        this.setState((state) => ({ 'selet_options': [] }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [] }));
                console.log(error);
            }
        }

        if (this.props.selectdata.name === 'doctor_name') {
            try {
                postService(getDoctorsforDropdown, 'GET', {}).then(res => {
                    if (res['status'] && res['data'] && res['data'].length>0) {
                        this.setState((state) => ({ 'select2options': res['data'], 'loading': false, 'fetching': false }));
                    } else {
                        this.setState((state) => ({ 'select2options': [] }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })
            } catch (error) {
                this.setState((state) => ({ 'select2options': [] }));
                console.log(error);
            }
        }

        if (this.props.selectdata.name === 'counselling_type') {
            try {
                
                // let newData = [{"id":1,"name":"Initial"},{"id":2,"name":"Re Counselling"}]
                // this.setState((state) => ({ 'select2options': newData, 'loading': false, 'fetching': false }));
                postService(getCounsellingType, 'GET', {}).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            this.setState((state) => ({ 'select2options': res['data'], 'loading': false, 'fetching': false }));
                        })
                    } else {
                        this.setState((state) => ({ 'selet_options': [] }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })

                // this.setState((state) => ({ 'selet_options': children }));
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [] }));
                console.log(error);
            }
        }
        if (this.props.selectdata.name === 'excludes_service_id') {
            let option_data = optionsStore.getState();
            console.log('excludes_service_id',option_data);
            this.setState((state) => ({ select2options: option_data, loading: false, fetching: false }), () => {
                if (this.props.selectdata.value) {
                    this.onChange(this.props.selectdata.value);
                }


                // option_data.map((data, key) => {
                //     children.push(<Option key={key} disabled={false} value={`${data.id}`} service={`${data.service}`} amount={`${data.price}`}>{`${data.service}`}</Option>)
                // })
                // this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                //     // this.inputBlur();
                // });
            })
        }
        if( this.props.selectdata.name === 'ot_hours' || 
        this.props.selectdata.name === 'room_isolation_charges' || 
        this.props.selectdata.name === 'icu_isolation_charges' || 
        this.props.selectdata.name === 'room_highend_investigations' ||
        this.props.selectdata.name === 'icu_highend_investigations' ||
        this.props.selectdata.name === 'room_highend_drugs_implants' ||
        this.props.selectdata.name === 'room_highend_implants' ||
        this.props.selectdata.name === 'icu_highend_drugs_implants' ||
        this.props.selectdata.name === 'ot_cath_highend_drugs_implants' ||
        this.props.selectdata.name === 'general_highend_equipments' ||
        this.props.selectdata.name === 'ot_equipments' ||
        this.props.selectdata.name === 'blood_components' ||
        this.props.selectdata.name === 'dept_for_corss_consultations' ||
        this.props.selectdata.name === 'physiotherapys' ||
        // this.props.selectdata.name === 'counselling_stations' ||
        this.props.selectdata.name === 'surgery_procedure_name' ||
        this.props.selectdata.name === 'ins_medical_record_charges' ||
        // this.props.selectdata.name === 'additional_surgery_procedure_name' ||
        this.props.selectdata.name === 'seropositive' ){
            // {
            //     "data": {
            //     "payment_type": 1,
            //     "unit_id": "UN2",
            //     "header_id": 8,
            //     "tariff_mapped": 1
            //     }
            // }
            let { basic_info } = this.props;
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            let user_unit_id = user_data.unitid;
            let payment_type =this.props.basic_info && this.props.basic_info['payment_type'];
            let tariff_id;
            if(this.props.basic_info !== undefined){
                if ( parseInt(basic_info['payment_type']) === 1 ){
                    tariff_id = 1;
                } 
            }

            let { counselling_details } = this.props;
            if(counselling_details){
                payment_type = counselling_details['payment_type_id'];
                if (payment_type === 1 ){
                    tariff_id = 1;
                } 
            }


            postService(getServicesByHeaderId, 'POST', { data: { payment_type : payment_type, unit_id : user_unit_id, header_id : this.props.selectdata.header, sub_header_id : this.props.selectdata.sub_header , tariff_mapped : 'TR1' ,search_key: val || '',} }).then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }),()=>{
                        if(this.props.selectdata.value){
                            this.onChange(this.props.selectdata.value);
                        }
                    });
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'ins_package_name' || this.props.selectdata.name === 'ins_additional_package_name' || this.props.selectdata.name === 'additional_package_name') {
            let { basic_info } = this.props
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            let user_unit_id = user_data.unitid;
            let payment_mode = basic_info['payment_type'];
            // let tariff = this.props.tariff_mapped ? parseInt(this.props.tariff_mapped) : null
            let tariff = this.props.tariff_mapped ? this.props.tariff_mapped : null
            let payload = {
                // "tariff_id" : "TR1",
                "search_key": val || '',
                "unit_id": user_unit_id
            }
            // postService(getPackagesForDropDown, 'POST', { "data": { "payment_type": 2, 'unit_id': user_unit_id, "tariff_mapped": tariff } }).then(res => {
            postService('getPackagesForDropDown', 'POST', {data:payload}).then(res => {
                if (res) {
                    let newData = [];
                    if (res.data.length !== 0) {
                        res.data.map((Data, Key) => {
                            // console.log('getPackagesForDropDown', res.data);
                            // newData.push({
                            //     'id': Data['id'],
                            //     'name': Data['package_name'],
                            //     'length_of_stay': Data['length_of_stay'],
                            //     'servicecd': Data['equservicecd']
                            // })
                            newData.push({
                                'id': Data['id'],
                                'name': Data['name'],
                                'servicecd': Data['service_code'],
                                'length_of_stay': Data['length_of_stay'],
                                'surgerycd': Data['surgerycd'],
                                'general_price': Data['general_price'],
                                'ispackage': Data['is_package']
                            })

                        })
                    }
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        const selectedData = ['ins_ot_hours','ins_room_isolation_charges','ins_icu_isolation_charges','ins_room_highend_investigations','ins_icu_highend_investigations','ins_room_highend_drugs_implants','ins_icu_highend_drugs_implants','ins_ot_cath_highend_drugs_implants','ins_general_highend_equipments','ins_ot_equipments','ins_blood_components','ins_dept_for_corss_consultations','ins_physiotherapys','ins_surgery_procedure_name','seropositive', 'ot_cath_instruments', 'ot_cath_disinfection_charges', 'ot_cath_cssd_charges', 'ot_cath_equipment_charges', 'ins_medical_record_charges','ins_ward_consumables','ins_fnb_charges','ins_physiotherapy_charges','ins_diet_consulation_charges','ins_surgery_procedure_charges']
        if (selectedData.includes(this.props.selectdata.name)) {
            // let { basic_info } = this.props;
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            let user_unit_id = user_data.unitid;
            let payload = {
                payment_type: 2,
                unit_id: user_unit_id,
                header_id: this.props.selectdata.header,
                sub_header_id: this.props.selectdata.sub_header,
                tariff_mapped: this.props.tariff_mapped ? this.props.tariff_mapped : 'TR1',
                search_key: val || '',
            }
            postService(getServicesByHeaderId, 'POST', { data: payload }).then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }), () => {
                        if (this.props.selectdata.value) {
                            this.onChange(this.props.selectdata.value);
                        }
                    });
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'nmename') {
            postService(getMasterNMEs, 'GET', null).then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
                   
            
                }

                if (this.props.selectdata.name === 'condition_name' || this.props.selectdata.name === 'pre_ex_condition_name') {
                    postService(getPreExistingConditions, 'GET', 'null').then(res => {
                        if (res) {
                            let newData = [];
                            if (res.data.length !== 0) {
                                res.data.map((roomData, roomKey) => {
                                    newData.push({
                                        'id': roomData['id'],
                                        'name': roomData['value']
                                    })
        
                                })
                            }
                            this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                        } else {
                            this.setState({ fetching: false });
                        }
                    });
                }

                if (this.props.selectdata.name === 'payer') {
                    let user_data = ''
                    if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                     user_data = JSON.parse(localStorage.getItem('user_data'))
                    }    
                    postService(getRemedinetPayerlist, 'POST', {
                        "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}   
                    }).then(res => {
                        if (res) {
                            this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                        } else {
                            this.setState({ fetching: false });
                        }
                    });
                } 
                if (this.props.selectdata.name === 'zone') { 
                    let user_data = ''    
                    if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                        user_data = JSON.parse(localStorage.getItem('user_data'))
                       }       
                  let payercode = localStorage.getItem('payercode');    
                    postService(getRemedinetZoneslist, 'POST', {
                        "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : '',"payercode":payercode?payercode:''}                   
                    }).then(res => {
                        if (res) {
                            this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                        } else {
                            this.setState({ fetching: false });
                        }
                    });
                } 
                if (this.props.selectdata.name === 'insurance_company_name') {     
                    let user_data = ''    
                    if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                        user_data = JSON.parse(localStorage.getItem('user_data'))
                       }       
                  let payercode = localStorage.getItem('payercode');          
                    postService(getRemedinetInsurancesCompanyList, 'POST', {
                        "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : '',"payercode":payercode?payercode:''}                   
                    }).then(res => {
                        if (res) {
                            this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                        } else {
                            this.setState({ fetching: false });
                        }
                    });
                } 
                if (this.props.selectdata.name === 'cathfilter') {     
                    let user_data = ''    
                    if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                        user_data = JSON.parse(localStorage.getItem('user_data'))
                       }       
                  let payercode = localStorage.getItem('payercode'); 
                  if(user_data['unitid']==='UN1'){
                      const data=
                        [{"id":"UN1","value":"Sec OT"},
                        {"id":"UN3","value":"Sec Cath OT "}]
                      
                        this.setState((state) => ({ select2options: data}));
                  }
                  if(user_data['unitid']==='UN2'){
                    const data= [{"id":"UN2","value":"Kondapur OT"}]
                    this.setState((state) => ({ select2options: data}));
                  }
                   
                } 
                if (this.props.selectdata.name === 'counsellor') {     
                   const privilage= localStorage.getItem('privilege_id')
                       postService(getUsersForTokenGenerator, 'POST', {
                        "data": { "privilege_id": privilage}                   
                    }).then(res => {
                        if (res) {
                            let newData = [];
                            if (res.data.length !== 0) {
                                res.data.map((roomData, roomKey) => {
                                    newData.push({
                                        'id': roomData['user_id'],
                                        'name': roomData['username']
                                    })
        
                                })
                            }
                            this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                        } else {
                            this.setState({ fetching: false });
                        }
                    });
                   
                } 
                if (this.props.selectdata.name === 'category') {  
                    let user_data = '';
                    let activity_type='';    
                    if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                        user_data = JSON.parse(localStorage.getItem('user_data'))
                       }   
                       activity_type= localStorage.getItem('activity_type'); 
                        postService(getCallLogCategories, 'POST', { "data": { "unit_id": user_data['unitid'],"activity_type": activity_type } }).then(res => {
                         if (res) {
                             this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                         } else {
                             this.setState({ fetching: false });
                         }
                     });
                    
                 }
                if (this.props.selectdata.name === 'reason') {  
                    let call_log_category_id='';    
                    call_log_category_id= localStorage.getItem('call_log_category_id'); 
                        postService(getCallLogCategoryReasons, 'POST', { "data": { "call_log_category_id": call_log_category_id } }).then(res => {
                         if (res) {
                             this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                         } else {
                             this.setState({ fetching: false });
                         }
                     });
                    
                }
                if (this.props.selectdata.name === 'activity_type') {
                    var data = [
                        {
                            'id': 'admission',
                            'name': 'Admission'
                        }, {
                            'id': 'due',
                            'name': 'Due'
                        },{
                            'id': 'estimate',
                            'name': 'Estimate'
                        }
                    ]
                    this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
                }
                if (this.props.selectdata.name === 'whatsapp_status') {
                    var data = [
                        {
                            'id': 1,
                            'name': 'Yes, Same as Registration Phone Number'
                        }, {
                            'id': 2,
                            'name': 'Yes, Alternate Phone Number'
                        }
                        , {
                            'id': 3,
                            'name': 'No'
                        }
                    ]
                    this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
                }
        
    }

    getQueuevalue(name) {
        let { Queuedata } = this.props;
        let value = null;
        Queuedata.filter(data => {
            if (data['name'] === name && data['valid']) {

                value = data['value'];
            }
        })
        return value;
    }
    getFormvalue(name) {
        let { formData } = this.props;
        let value = null;
        formData.filter(data => {
            if (data['name'] === name && data['valid']) {

                value = data['value'];
            }
        })
        return value;
    }

    render() {
        const { fetching } = this.state;
        // console.clear();
        let defaultallowClear = false;
        let allowClear = false;
        let mode = 'single';
        let defvalue = null;
        let valueText = this.state.selectdata.text ? this.state.selectdata.text : null;
        // console.log(this.state.selectdata.text);
        const Option = Select.Option;
        const children = [];
        if (this.state.select2options.length !== 0) {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id !== null) {
                        children.push(
                            <Option key={key} value={data.id} disabled={data.disabled ? data.disabled : false}>{data.name
                                ? data.name
                                : (data.value ||data.service_name)}</Option>
                        );
                    }

                });
        }
        if (this.props.selectdata.name === 'additional_procedure') {
            mode = 'multiple'
            defvalue = [];
            valueText = []
        }
        if (this.props.selectdata.name === 'room_upgrade') {
            defaultallowClear = true;
        }


        // console.log(this.state.selectdata);

        return (

            <Select
                showSearch
                mode={mode}
                style={{
                    width: '100%',
                    height: '30px'
                }}
                placeholder={this.props.selectdata.placeholder}
                defaultValue={defvalue}
                allowClear={defaultallowClear}
                value={this.state.selectdata.text ? this.state.selectdata.text.toString() : null}
                optionFilterProp="children"
                onChange={this
                    .onChange
                    .bind(this)}
                onFocus={this
                    .onFocus
                    .bind(this)}
                onBlur={this
                    .onBlur
                    .bind(this)}
                notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                onSearch={this.onSearch}
                disabled={this.state.selectdata.disable}
                loading={false}
                // menuItemSelectedIcon={< Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                dropdownMatchSelectWidth={false}>
                {children}
            </Select>
        );
    }
}

export default Select2;
